import { Component, OnInit } from '@angular/core';
import { SEOService } from '../../core/seo.service';

@Component({
  selector: 'app-potential-risks-blog-two',
  templateUrl: './potential-risks-blog-two.component.html',
  styleUrls: ['./potential-risks-blog-two.component.scss']
})
export class PotentialRisksBlogTwoComponent implements OnInit {
  constructor(
    private seoService: SEOService
  ) { }

  ngOnInit(): void {
    this.setSeo();
  }

  setSeo(): void {
    this.seoService.updatePageTitle('Rapinno Tech Blog | POTENTIAL RISKS OF POOR DATA Security Part 2');
    this.seoService.updateOgTitle('Rapinno Tech Blog | POTENTIAL RISKS OF POOR DATA Security Part 2');
    this.seoService.updateOgDescription('This Blog describes the methodologies to keep the data secure from your end through Tokenisation & security management solution');
    this.seoService.updateOgType('Blog');
    this.seoService.updateOgImage('https://rapinnotech.com/assets/images/blog/8.webp');
    this.seoService.updateOgUrl('https://www.rapinnotech.com/resources/potential_risks_of_poor_data_security_part2');
    this.seoService.updateMetaTitle('Rapinno Tech Blog | POTENTIAL RISKS OF POOR DATA Security Part 2'),
      this.seoService.updateMetaDescription('This Blog describes the methodologies to keep the data secure from your end through Tokenisation & security management solution.')
  }
}
